import { IResolvers } from '@workbench-stack/core';

export const workspaceResolver: (services: any) => IResolvers = (services: any) => ({
    Mutation: {
        addFolders: async (_, args, context) => {
            await services().workspaceContextService.addFolders(args.folders, args.index);
            await services().configurationService.reloadConfiguration();
            return true;
        },
        removeFolders: async (_, args, context) => {
            await services().workspaceContextService.removeFolders(args.folders);
            await services().configurationService.reloadConfiguration();
            return true;
        },
        updateFolders: async (_, args, context) => {
            await services().workspaceContextService.updateFolders(args.foldersToAdd, args.foldersToRemove, args.index);
            await services().configurationService.reloadConfiguration();
            return true;
        },
        changeWorkspace: async (_, { args }, context) => {
            await services().workspaceContextService.initialize(args);
            await services().configurationService.reloadConfiguration();
            return true;
        },
    },
} as IResolvers);
